/**
 * The cover's Contact line (Myriam QA-006, 13438750443). With no company picked
 * `useContractCompany` falls back to a record whose name is the literal
 * "[[Select a company for the contract]]", and that printed on the cover.
 * Hidden until a company is picked. A report already signed keeps its cover as
 * it was (V67).
 */
export const coverContactCompany = (
  company: { readonly longName: string; readonly shortName: string },
  signed: boolean,
): string => (company.shortName || signed ? company.longName : '')
